import DeviceHistoryService from './device-history.service';
export default DeviceHistoryService;